import { useEffect, useState } from 'react'
import SubheaderPopover from 'components/common/mygame/subheader/popover/subheader-popover'
import { GROUPS_MANAGEMENT_EMPTY, GROUPS_SPORTS, GROUPS_STORES } from 'core/constants/translations/groups'
import { trackAnalyticsEvent } from '../../../../../core/hooks/useAnalytics'
import { useTranslation } from 'react-i18next'

const SubheaderGroups = ({ shortcutSportsGroups, shortcutStoresGroups }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const [groupClicked, setGroupClicked] = useState()

  const handlePopover = group => {
    if (group !== groupClicked) setGroupClicked(group)
    setIsOpen(true)

    if (group === groupClicked) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    if (isOpen === false) {
      setGroupClicked(null)
    }
  }, [isOpen])

  const handleClickShortcutManageGroups = (groupType: string) => {
    const googleAnalyticsAction =
      groupType === 'sport' ? 'click_shortcut_group_management_sport' : 'click_shortcut_group_management_store'
    trackAnalyticsEvent(googleAnalyticsAction)
    handlePopover(groupType)
  }
  return (
    <>
      {shortcutSportsGroups || shortcutStoresGroups ? (
        <div className="mg-subheader-nav-groups__manage vtmn-typo_text-3">{t(GROUPS_MANAGEMENT_EMPTY)}</div>
      ) : null}
      {shortcutSportsGroups && (
        <div
          onClick={() => {
            handleClickShortcutManageGroups('sport')
          }}
        >
          <button
            type="button"
            id="trigger-popover-sports"
            className="vtmn-btn vtmn-btn_variant--secondary vtmn-btn_size--small"
          >
            {t(GROUPS_SPORTS)}
          </button>
        </div>
      )}
      {shortcutStoresGroups && (
        <div
          onClick={() => {
            handleClickShortcutManageGroups('store')
          }}
        >
          <button
            type="button"
            className="vtmn-btn vtmn-btn_variant--secondary vtmn-btn_size--small mg-subheader-shortcut"
            id="trigger-popover-stores"
          >
            {t(GROUPS_STORES)}
          </button>
        </div>
      )}
      {isOpen && <SubheaderPopover groupClicked={groupClicked} setIsOpen={setIsOpen} isOpen={isOpen} />}
    </>
  )
}

export default SubheaderGroups
